export enum OfferPaymentActionType {
    PAYMENT = 0,
    INTENT = 1,
    NONE = 2
}